// services
import { storeApplicationName } from "@/services/solution/solutionService";
import {
  storeUsesModalJump,
  getStoredUsesModalDialogJump,
  storeUsesAppTabs,
  getStoredUsesAppTabs,
  getStoredUsesSidebarImage,
  storeUsesSidebarImage,
  storeDialogToolbarStyle,
  storeCommandButtonTextStyle,
  getDialogToolbarStyle,
  getCommandButtonTextStyle,
  storeCommandButtonOutlined,
  getCommandButtonOutlined,
  storeButtonColor,
  storeToolbarDetailsColor,
  getStoredButtonColor,
  getToolbarDetailsColor
} from "@/services/user/userService";

// Axillary
import { toLowerCaseSafe } from "@/utils";

// store
import {
  INITIALIZE_STATES,
  SET_APPLICATION,
  SET_DRAWER,
  SET_DRAWER_RIGHT,
  SET_VISIBLE_JUMP,
  SET_VISIBLE_OPTIONS,
  SET_USES_APP_TABS,
  SET_USES_MODAL_JUMP,
  SET_USES_SIDEBAR_IMAGE,
  SET_DIALOG_TOOLBAR_STYLE,
  SET_COMMAND_COLOR,
  SET_COMMAND_BUTTONS_TEXT_STYLE,
  SET_COMMAND_BUTTONS_OUTLINED,
  SET_TOOLBAR_DETAILS_COLOR
} from "./mutation-types";

const mutations = {
  /**
   * Initialize states by using saved local storage data
   * @param state
   */
  [INITIALIZE_STATES]: state => {
    try {
      let store = getStoredUsesModalDialogJump();
      if (store) {
        const value = toLowerCaseSafe(store) === "true";
        if (state.usesModalDialogJump !== value) {
          state.usesModalDialogJump = value;
        }
      }
      store = getStoredUsesAppTabs();
      if (store) {
        const value = toLowerCaseSafe(store) === "true";
        if (state.usesAppTabs !== value) {
          state.usesAppTabs = value;
        }
      }
      store = getStoredUsesSidebarImage();
      if (store) {
        const value = toLowerCaseSafe(store) === "true";
        if (state.usesSidebarImage !== value) {
          state.usesSidebarImage = value;
        }
      }
      store = getDialogToolbarStyle();
      if (store) {
        const value = toLowerCaseSafe(store) === "true";
        if (state.dialogToolbarStyle !== value) {
          state.dialogToolbarStyle = value;
        }
      }
      store = getCommandButtonTextStyle();
      if (store) {
        const value = toLowerCaseSafe(store) === "true";
        if (state.commandButtonsTextStyle !== value) {
          state.commandButtonsTextStyle = value;
        }
      }
      store = getCommandButtonOutlined();
      if (store) {
        const value = toLowerCaseSafe(store) === "true";
        if (state.commandButtonsOutlined !== value) {
          state.commandButtonsOutlined = value;
        }
      }
      store = getStoredButtonColor();
      if (store) {
        const value = toLowerCaseSafe(store) === "true";
        if (state.buttonColor !== value) {
          state.buttonColor = value;
        }
      }
      store = getToolbarDetailsColor();
      if (store) {
        const value = toLowerCaseSafe(store) === "true";
        if (state.toolbarDetailsColor !== value) {
          state.toolbarDetailsColor = value;
        }
      }
    } catch (err) {
      console.error(err);
    }
  },

  /**
   * Set current application
   * @param state
   * @param  {{title: String, icon: String, name: String}} payload
   * @constructor
   */
  [SET_APPLICATION]: (state, payload) => {
    state.application = payload;
    storeApplicationName(state.application.name);
  },
  /**
   * Show/Hide drawerLeft
   * @param state
   * @param {Boolean} payload
   * @constructor
   */
  [SET_DRAWER]: (state, payload) => {
    state.drawerLeft = payload;
  },
  /**
   * Show/Hide right drawerLeft
   * @param state
   * @param {Boolean} payload
   * @constructor
   */
  [SET_DRAWER_RIGHT]: (state, payload) => {
    state.drawerRight = payload;
  },
  /**
   * Indicate that Jump commands should be available (visible)
   * @param state
   * @param {Boolean} payload
   * @constructor
   */
  [SET_VISIBLE_JUMP]: (state, payload) => {
    state.visibleJump = payload;
  },
  /**
   * Indicate that Options commands should be available (visible)
   * @param state
   * @param {Boolean} payload
   * @constructor
   */
  [SET_VISIBLE_OPTIONS]: (state, payload) => {
    state.visibleOptions = payload;
  },
  /**
   *  Uses Tabs as a Application selector
   * @param state
   * @param {Boolean} payload
   * @constructor
   */
  [SET_USES_APP_TABS]: (state, payload) => {
    state.usesAppTabs = payload;
    storeUsesAppTabs(state.usesAppTabs);
  },
  /**
   * Uses Modal Jump Dialog as a module selector
   * @param state
   * @param {Boolean} payload
   */
  [SET_USES_MODAL_JUMP]: (state, payload) => {
    state.usesModalDialogJump = payload;
    storeUsesModalJump(state.usesModalDialogJump);
  },
  /**
   * Uses Sidebar Image
   * @param state
   * @param {Boolean} payload
   */
  [SET_USES_SIDEBAR_IMAGE]: (state, payload) => {
    state.usesSidebarImage = payload;
    storeUsesSidebarImage(state.usesSidebarImage);
  },
  [SET_DIALOG_TOOLBAR_STYLE]: (state, payload) => {
    state.dialogToolbarStyle = payload;
    storeDialogToolbarStyle(state.dialogToolbarStyle);
  },
  [SET_COMMAND_COLOR]: (state, payload) => {
    state.buttonColor = payload;
    storeButtonColor(state.commandColor);
  },
  [SET_COMMAND_BUTTONS_TEXT_STYLE]: (state, payload) => {
    state.commandButtonsTextStyle = payload;
    storeCommandButtonTextStyle(state.commandButtonsTextStyle);
  },
  [SET_COMMAND_BUTTONS_OUTLINED]: (state, payload) => {
    state.commandButtonsOutlined = payload;
    storeCommandButtonOutlined(state.commandButtonsOutlined);
  },
  [SET_TOOLBAR_DETAILS_COLOR]: (state, payload) => {
    state.toolbarDetailsColor = payload;
    storeToolbarDetailsColor(state.toolbarDetailsColor);
  }
};

export default mutations;
